/* eslint-disable local-rules/chakra-token */
import { createIcon } from "@chakra-ui/icons";

// Created from model-schematisation.svg

export const SchematisationIcon = createIcon({
  displayName: "ModelSchematisation",
  viewBox: "0 0 18 18",
  path: (
    <g>
      <rect width="18" height="18" rx="2" fill="#CFE1EE" />
      <line x1="4.5" y1="2.18557e-08" x2="4.5" y2="18" stroke="#69A0C9" />
      <line x1="13.5" y1="2.18557e-08" x2="13.5" y2="18" stroke="#69A0C9" />
      <line x1="-4.37114e-08" y1="14.5" x2="18" y2="14.5" stroke="#69A0C9" />
      <line y1="3.5" x2="18" y2="3.5" stroke="#69A0C9" />
      <circle cx="4.215" cy="3.215" r="2.215" fill="#69A0C9" />
      <circle cx="13.215" cy="3.215" r="2.215" fill="#69A0C9" />
      <circle cx="4.215" cy="14.3888" r="2.215" fill="#69A0C9" />
      <circle cx="13.215" cy="14.3888" r="2.215" fill="#69A0C9" />
    </g>
  ),
});
